import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Lock-index-1992f2b76c3d58695-1'),
    routerUrl: '/LockMotorcade',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./LockMotorcade')),
    children: [
      //$MORE$
    ],
  },
];
